// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".two-fa-dialog {\n  box-shadow: none;\n}\n@media (min-height: 720px) {\n.two-fa-dialog {\n    position: relative;\n    top: -84px;\n}\n}\n@media (min-width: 600px) {\n.two-fa-dialog {\n    top: -104px;\n}\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
